// Imports

import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';


// Stateful components

export class Tooltip extends React.Component{

    // Lifecycle

    constructor(props) {
        super(props);

        this.state = {
            'return_element': null,
            'open': false
        };

        this.keypressHandler = this.keypressHandler.bind(this);
        this.backgroundClickHandler = this.backgroundClickHandler.bind(this);
        this.setModalRef = this.setModalRef.bind(this);
        this.renderTooltipContent = this.renderTooltipContent.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
    }

    componentDidMount() {
        var this_component = this;

    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;
        var opened = this_component['state']['open'];
        if (opened !== prev_state['open'] && opened === true) {
            setTimeout(function() {
                this_component.setFocusOnTooltip();
            }, 50);
        }
    }


    // Functions


    setModalRef(node) {
        var this_component = this;
        this_component['modal_ref'] = node;
    }

    keypressHandler(event) {
        var this_component = this;

        // ESC
        if(event.keyCode === 27) {
            this_component.toggleTooltip(event);
        }
    }

backgroundClickHandler(event) {
    var target_elemet = event['target'];
    var this_component = this;
    var bad_elements = ['input'];
    var element_tag = target_elemet['tagName'].toLowerCase();

    if(this_component['modal_ref'] && !this_component['modal_ref'].contains(target_elemet)) {
        if(bad_elements.indexOf(element_tag) === -1) {
            event.preventDefault();
            event.stopPropagation();
            this_component.toggleTooltip(event);
        }
    }
}

    toggleTooltip(event) {
        event.stopPropagation();
        var this_component = this;
        var open = !this_component['state']['open'];

        if (open) {
            // Get active element to return focus to
            this_component.setReturnElement();

            // Keypress handler
            document.addEventListener("keydown", this_component.keypressHandler, false);

            document.addEventListener("click", this_component.backgroundClickHandler, false);
        } else {
            
            // Return focus state
            var return_element = this_component['state']['return_element'];
            this_component.setFocusOnElement(return_element);

            document.removeEventListener("keydown", this_component.keypressHandler, false);

            document.removeEventListener("click", this_component.backgroundClickHandler, false);
        }


        this_component.setState({
            open: open
        });

    }

    setReturnElement() {
        var this_component = this;
        var active_element = document.activeElement;

        this_component.setState({
            'return_element': active_element
        });
    }

    setFocusOnElement(target_element) {
        // Send user to destination element
        target_element["tabIndex"] = -1;
        target_element.focus();
        target_element["tabIndex"] = 0;
    }

    setFocusOnTooltip() {
        var this_component = this;
        var target_element = document.querySelector('.info-modal__dialogue');
        this_component.setFocusOnElement(target_element);
    }

    


    // Render

    renderTooltipContent() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var configuration = portal_context['configuration'];

        var content = this_component['props']['content'];
        var title = content['title'] ? content['title'] : '';
        var info = content['info'] ? {__html: content['info']} : {__html: null};
        
        var email = null;
        if (content['email']) {
            var icon_email = configuration['icons']['email'];
            email = (
                <a href={"mailto:" + content['email']} className="info-modal__email">
                    <span className="info-modal__email__icon" dangerouslySetInnerHTML={{__html: icon_email}}></span>
                    <span className="info-modal__email__address">
                        {content['email']}
                    </span>
                </a>
            );
        }

        var link = null;
        if (content['link']) {
            var url = helpers.getDynamicLinkUrlById(content['link']);
            link = <a href={url} className="info-modal__link">{content['link_text']}</a>;
        }

        return (
            <div ref={this_component.setModalRef} className="info-modal__dialogue">
                <div className="info-modal__row">
                    <button className="info-modal__close" onClick={this_component.toggleTooltip}>
                        Close
                    </button>
                </div>
                <div className="info-modal__name">
                    {title}
                </div>
                <div className="info-modal__info" dangerouslySetInnerHTML={info}></div>
                {link}
                {email}
            </div>
        );
    }

    renderTooltipButton () {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        
        var info_icon = null;
        if (configuration['icons']) {
            info_icon = configuration['icons']['info'];
        }

        var tooltip_content = this_component['props']['content'];
        var btn_class = '';
        var btn_text = 'Click here';
        if (tooltip_content['button']) {
            btn_class = tooltip_content['button']['class'];
            btn_text = tooltip_content['button']['text'];
        }
        
        return (
    
            <button className={btn_class} onClick={this_component.toggleTooltip}>
                {btn_text}
                <span className="info-modal__icon" dangerouslySetInnerHTML={{__html: info_icon}}></span>
            </button>

        );
    }


    render() {
        var this_component = this;
        var open = this_component['state']['open'];
        var tooltip_content = open ? this_component.renderTooltipContent() : null;
        var tooltip_button = this_component.renderTooltipButton();
        var active_class = open ? ' modal--open' : '';
        
        return (
            <div className={"tooltip__wrapper" + active_class}>
                {tooltip_content}
                {tooltip_button}
            </div>
        );
    
    }
};

Tooltip.contextType = PortalContext;
